import axios from "axios";
import router from "../router/index";
import $ from "jquery";
import Vue from "vue";
const accesslogs = {
  state: () => ({
    items: [],
    filter: {
      skip: 0,
      take: 20,
      searchTerm: null,
      status: null,
      type: null,
      venueID: null,
      participantNO: null,
      page: 1,
    },
    selectedItems: [],
    loading: true,
    participants: [],
    users: [],
    liveStreams: [],
  }),
  
  mutations: {
    setAccessLogs(state, payload) {
      state.items = payload.items;
      state.participants = payload.participants;
      state.filter.total = payload.total;
      state.users = payload.users;
      state.liveStreams = payload.liveStreams;
    },
    setSelectedAccessLogs(state, payload) {
      state.selectedItems = payload;
    },
    setAccessLogPage(state, payload) {
      state.filter.page = payload;
      this.dispatch("getAccessLogs");
    },
    setAccessLogTake(state, payload) {
      state.filter.page = 1;
      state.filter.take = payload;
      this.dispatch("getAccessLogs");
    },
  },

  actions: {
    async getAccessLogs(store) {
      store.state.loading = true;
      await axios
        .post("accesslog/load", {
          ...store.state.filter,
          skip: (store.state.filter.page - 1) * store.state.filter.take,
        })
        .then((res) => {
          store.state.loading = false;
          return store.commit("setAccessLogs", res.data.data);
        });
    },

    async deleteAccessLog(store, payload) {
      await axios
        .post("accesslog/delete", {
          id: store.state.items[payload.index].id,
        })
        .then((res) => {
          if (res.data.alert.hasError) {
            payload.context.$message.error(res.data.alert.message);
          } else {
            store.state.items.splice(payload.index, 1);
            payload.context.$message.success(res.data.alert.message);
            if (store.state.items.length == 0 && store.state.filter.page != 1) {
              this.commit("setAccessLogPage", store.state.filter.page - 1);
            }
            store.state.filter.total = store.state.filter.total - 1;
          }
        });
    },
  },
  getters: {},
};
export default accesslogs;



// WEBPACK FOOTER //
// ./src/store/accesslogs.js